<template>
    <div class="header align-center">
        <van-nav-bar @click-left="onClickLeft" @click-right="onClickRight" >
            <span slot="left" v-if="isshow">
                <van-icon name="arrow-left" size="20" />{{backText}}
                </span>

                <span slot="left" v-if="isshow&&isdatabase&&path=='database'">
                <van-icon name="arrow-left" size="20" />首页
                </span>
            <span slot="title" v-if='title_only'>
                {{title}}
            </span>
            <span slot="title" v-else >


                    <div class="head-tab">
                        <van-tabs  @click="handleSport" >
                            <van-tab title="足球" name="1"/>
                            <van-tab title="篮球" name="2"/>
                        </van-tabs>
                    </div>

            </span>
            
            <div  v-if="isSearch">
            <van-icon  name="search" slot="right" size="24" color="#333"/>
            </div>
        </van-nav-bar>
    </div>
</template>
<script>
export default {
    name: 'Header',
    props: {
        Pagetitle: {
            type: String,
            value: '体育推介网',
        }
    },
    data() {
        return {
            title: this.Pagetitle,
            backText: '返回',
            path: '',
            isSearch: true, //默认vant头
            isshow: true,
            isdatabase:false,
            rootPage: ['home', 'schedule', 'agency','database','center',],
            activeName: 1,
            sport: 1,
            title_only:true,
            //sport_path:['basketball'],
            sport_path:[''],
          

        }
    },
    watch: {
        $route(to, from) {
            // console.log('to', to, 'from', from)
            this.path = to.name ? (to.name).toLowerCase() : 'home'

             //console.log( 'path',  this.path)
            let rootPage = this.rootPage

            if(this.path=='database')
            {
                this.isdatabase = true;
            }else{
                 this.isdatabase = false;
            }
                        // console.log('path', this.path)
            this.isSearch = this.path == 'news' ? false : true;
            this.title = to.meta.title || '推介网';

            let show_sport = this.sport_path.indexOf(this.path);
            if ( show_sport != -1){
                this.title_only = false;
            }else{
                this.title_only = true;
            }

        //   console.log('joan',this.path)
        //     console.log('jdjdjd',rootPage.indexOf(this.path))
            if ((rootPage.indexOf(this.path) != -1)) {
                this.isshow = false;
            } else {
                this.isshow = true;
            }
           
        },

        Pagetitle(newValue) {
            if (newValue != ''){
                this.title = newValue               
            }
        }
        /* // watch擅长处理的场景：一个数据影响多个数据
         'activeName':function(val) { //监听切换状态-计划单
             // 注释，根据val的不同，跳转到不同
             console.log('header首页activeName', val);
             this.sport = val;
             console.log('header的sport', val);

         },*/
    },

    created() {
        if (this.path == '') { //首次进入
            let current = this.$router.currentRoute
            let rootPage = this.rootPage
            let currentName = current.name ?  (current.name).toLowerCase() : 'home'
            this.rounterName = this.path = currentName
            this.title = current.meta.title || '推介网'
            this.isSearch = this.path == 'news' ? false : true;

            let show_sport = this.sport_path.indexOf(this.path);
            if ( show_sport != -1){
                this.title_only = false;
            }else{
                this.title_only = true;
            }

            if (rootPage.indexOf(currentName) != -1) {
                this.isshow = false;
            } else {
                this.isshow = true;
            }

       
        }

    },
    methods: {
        onClickLeft() {

            if( this.isdatabase == true)
            {
                this._goPush('Home');

            }else{
                this._goBack()
            }
            
        },
        onClickRight() {
            this._goPush('Search');
        },
        dropdownChange(index){

            let data = this.dropdown_option[index];
            let path = (this.path).toLowerCase();
            if (data){
                if (path == data.path){
                    return;
                }else{
                    this._goReplace(data.path);
                }
            }
        },
        handleSport(tab){
        }
    },

}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/components/Header.vue